import React from "react";
import { cn } from "@/lib/utils";

const SectionSeparator = ({ className }: { className?: string }) => {
  return <div className={cn("h-1 w-full bg-[#F5F7FF]", className)}></div>;
};

export default SectionSeparator;
